import { updateEvent } from '../../services/eventService';
import { updateCalculs } from '../../services/calculService';
import { formatDateForInput } from '../../ui-tools/dateUtils';
import { initEventList } from './index';

// Fonction pour afficher le modal d'édition des dates
export function showDateEditModal(event) {
  // Créer et afficher le modal
  const modal = document.createElement('div');
  modal.className = 'modal';

  const startDate = new Date(event.startDate);
  const endDate = new Date(event.endDate);

  // Formater les dates pour les inputs date
  const startDateValue = formatDateForInput(startDate);
  const endDateValue = formatDateForInput(endDate);

  modal.innerHTML = `
    <div class="modal-content">
      <span class="close-modal">&times;</span>
      <h2>Modifier les dates</h2>
      <form id="edit-dates-form">
        <div class="form-row">
          <div class="form-group">
            <label for="edit-start-date">Date de début</label>
            <input type="date" id="edit-start-date" name="edit-start-date" value="${startDateValue}" required>
          </div>
          <div class="form-group">
            <label for="edit-end-date">Date de fin</label>
            <input type="date" id="edit-end-date" name="edit-end-date" value="${endDateValue}" required>
          </div>
        </div>
        <div class="form-actions">
          <button type="submit" class="btn-save">Enregistrer</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(modal);

  // Écouteur pour la date de début
  const startDateInput = document.getElementById('edit-start-date');
  const endDateInput = document.getElementById('edit-end-date');

  startDateInput.addEventListener('change', () => {
    // Si la date de fin est antérieure à la nouvelle date de début,
    // mettre à jour la date de fin pour qu'elle soit égale à la date de début
    if (new Date(endDateInput.value) < new Date(startDateInput.value)) {
      endDateInput.value = startDateInput.value;
    }
  });

  // Fermer le modal
  const closeBtn = modal.querySelector('.close-modal');
  closeBtn.addEventListener('click', () => {
    document.body.removeChild(modal);
  });

  // Fermer le modal si on clique en dehors (sauf si on ferme lors de la sélection de texte)
  modal.addEventListener('mousedown', (e) => {
    if (e.target === modal) {
      modal.dataset.closeOnMouseUp = 'true';
    } else {
      modal.dataset.closeOnMouseUp = 'false';
    }
  });

  document.addEventListener('mouseup', (e) => {
    if (e.target === modal && modal.dataset.closeOnMouseUp === 'true') {
      document.body.removeChild(modal);
    }
  });

  // Gérer la soumission du formulaire
  const form = document.getElementById('edit-dates-form');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    try {
      const newStartDate = document.getElementById('edit-start-date').value;
      const newEndDate = document.getElementById('edit-end-date').value;

      if (new Date(newEndDate) < new Date(newStartDate)) {
        alert('La date de fin doit être égale ou postérieure à la date de début');
        return;
      }

      // Mettre à jour l'événement
      const updatedEvent = { ...event, startDate: newStartDate, endDate: newEndDate };
      await updateEvent(updatedEvent.id, updatedEvent);

      // Fermer le modal
      document.body.removeChild(modal);

      // Rafraîchir l'affichage
      await initEventList();
      await updateCalculs();
    } catch (error) {
      console.error('Erreur lors de la mise à jour des dates:', error);
      alert('Erreur lors de la modification des dates');
    }
  });
}